/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  return {
    variables: {
      first_name: `%${props.firstName.trim()}%`,
      last_name: `%${props.lastName.trim()}%`,
      birth_date: props.birthDate,
      birth_date_s: props.birthDate,
    },
    pause: !props.firstName || !props.lastName || !props.birthDate,
  }
}
